import type { ShopItem } from '../types'
/** UI defense in depth; the backend independently checks native goods and catalog membership. */
export function isMvpShopProduct(item: ShopItem): boolean {
    return (item.type === 'chips' || item.type === 'ultimate-pass') && !/offer.?chain/i.test(`${item.subType || ''} ${item.eventType || ''}`)
}
